/* eslint-disable eqeqeq */
import React, {useState, Fragment} from "react";
import axios from "axios";


export const CreateVoucherComponent = ({users, setalert}) => {
    // eslint-disable-next-line no-unused-vars
    const [user, setUser] = useState({});
    const [id, setId] = useState("");
    const [bundles, setBundles] = useState([])
    const [variationCode, setVariationCode] = useState("")
    const [amount, setAmount] = useState("");
    const [network, setNetwork] = useState("");
    const [networkUsers, setNetworkUsers] = useState([])
    const [userNetworkBundles, setUserNetworkBundles] = useState([])
    const [variationCodeForNetwork, setVariationCodeForNetwork] = useState("")

    const handleChange = async(e) => {
        const id = e.target.value;
        setId(id);
        const userObject = users.find((user) => user._id == id);
        console.log(users)
        setUser(userObject);
        const bundles = await axios.get(`/databundles?provider=${userObject.network}`);
        const dataBundles = bundles.data.data;
        setBundles(dataBundles);

    }

    const handleDataBundleChange = (e) => {
        const variationCode = e.target.value;
        const bundleObject = bundles.find((bundle) => bundle.variation_code == variationCode);
        setVariationCode(variationCode);
        setAmount(bundleObject.variation_amount);
    }

    const createVoucher  = async() => {
        const body = {
            'user_id': id,
            'variation_code': variationCode,
            'variation_amount': amount
        };
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        try{
            const createVoucher = await axios.post('/generatevoucher', body, {config});
            if(createVoucher.data.status === 'success'){
                setalert('SUCCESS', 'success');
            }
        }catch(error){
            console.log(error)
            setalert('FAILED', 'danger')
        }

    }

    const handleNetworkChange = async(e) => {
        const network = e.target.value;
        setNetwork(network)
        const usersObject = users.filter((user) => user.network == network);
        //console.log(usersObject);
        setNetworkUsers(usersObject);
        const bundles = await axios.get(`/databundles?provider=${network}`);
        const dataBundles = bundles.data.data;
        setUserNetworkBundles(dataBundles);
    }
    const handleDataBundleChangeForNetwork = (e) => {
        const variationBundleChange = e.target.value;
        setVariationCodeForNetwork(variationBundleChange);
    }

    const handleCreateMultipleVouchers = async() => {
        console.log(networkUsers)
        console.log(variationCodeForNetwork);
        const bundleObject = userNetworkBundles.find((bundle) => bundle.variation_code == variationCodeForNetwork);
        const bundleAmount = bundleObject.variation_amount;
        let config = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        for (const user1 of networkUsers) {
            let body = {
                'user_id': user1._id,
                'variation_code': variationCodeForNetwork,
                'variation_amount': bundleAmount
            };

            try {
                let createVoucher = await axios.post('/generatevoucher', body, {config});
                if (createVoucher.data.status === 'success') {
                    setalert('SUCCESS', 'success');
                }
            } catch (error) {
                console.log(error)
                setalert('FAILED', 'danger')
            }
        }
    }
    return (
        <Fragment>
            <div className="dashboard-card">

                <h1 className="transaction-title-header">Create voucher for user</h1> <br/>
               <div className="row">
                   <div className="col-md-6">
                       <div className="oi-form-group">
                           <label className="secondary-header-text" htmlFor="user">
                               Users
                           </label>
                           <select name="user_id"  onChange={handleChange} value={id}>
                               <option value="" disabled>Choose a user</option>
                               {users.map((user, index) => (
                                   <option value={user._id} key={user._id}>{user.email}</option>
                               ))}
                           </select>
                       </div>
                   </div>
                   <div className="col-md-6">
                       <div className="oi-form-group">
                           <label className="secondary-header-text" htmlFor="bundle">
                               Data bundle
                           </label>
                           <select name="variation_code" id="bundle" onChange={handleDataBundleChange} value={variationCode}>
                               <option value="" disabled>Choose a bundle</option>
                               {bundles.map((bundle, index) => (
                                   <option value={bundle.variation_code} key={index}>{bundle.name}</option>
                               ))}

                           </select>
                       </div>
                   </div>
               </div>
                <div className="button-wrapper">
                    <button onClick={createVoucher}
                        className="oi-button oi-big-button margin-top-small"
                    >Create Voucher
                    </button>
                </div>

                <h1 className="transaction-title-header">Create voucher for network users</h1> <br/>
                <div className="row">

                    <div className="col-md-6">
                        <div className="oi-form-group">
                            <label className="secondary-header-text" >
                                Network
                            </label>
                        <select name="network" value={network} onChange={handleNetworkChange}>
                            <option value="" disabled>Select network</option>
                            <option value="mtn">Mtn</option>
                            <option value="airtel">Airtel</option>
                            <option value="glo">Glo</option>
                            <option value="etisalat">Etisalat</option>
                        </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="oi-form-group">
                            <label className="secondary-header-text" htmlFor="bundle2">
                                Data bundle
                            </label>
                            <select name="variation_code" id="bundle2" onChange={handleDataBundleChangeForNetwork} value={variationCodeForNetwork}>
                                <option value="" disabled>Choose a bundle</option>
                                {userNetworkBundles.map((bundle, index) => (
                                    <option value={bundle.variation_code} key={index}>{bundle.name}</option>
                                ))}

                            </select>
                        </div>
                    </div>
                </div>
                <div className="button-wrapper">
                    <button onClick={handleCreateMultipleVouchers}
                            className="oi-button oi-big-button margin-top-small"
                    >Create multiple vouchers
                    </button>
                </div>
            </div>
        </Fragment>
  );
}